import makeActionCreator from './makeActionCreator';
import {
  __INTERNAL_DEVTOOLS_HIDE__,
  __INTERNAL_DEVTOOLS_SHOW__,
  __INTERNAL_DIALOG_HIDE__,
  __INTERNAL_DIALOG_SHOW__
} from './actionTypes';

/**
 * JSDoc for showDialog options object
 *
 * @typedef {Object} DialogOptions
 * @param {object}
 * @property {string} [title]
 * @property {Object} [body]
 * @property {string} [ok]
 * @property {string} [cancel]
 * @property {function} [onOk]
 * @property {function} [onCancel]
 */

/**
 * @type {function(DialogOptions): {type: *}}
 */
export const showDialog = makeActionCreator(__INTERNAL_DIALOG_SHOW__, 'options');
export const hideDialog = makeActionCreator(__INTERNAL_DIALOG_HIDE__);

export const showDevtools = makeActionCreator(__INTERNAL_DEVTOOLS_SHOW__);
export const hideDevtools = makeActionCreator(__INTERNAL_DEVTOOLS_HIDE__);
